import React from 'react';
import {useSelector} from 'react-redux';

import {labels} from '../../../../util/utils';

import CountWithTooltip from '../CountWithTooltip';

const ClientsCount = () => {
	const project = useSelector(({project}) => project);

	const getClientList = () => (project?.clients ? project.clients.map(({name}) => name) : []);

	const props = {
		inactiveLabel: labels.connectedTo,
		activeLabel: ` ${project?.clients ? labels.connectedToClients(project.clients.length) : ''}`,
		countLabel: labels.client,
		itemList: [...getClientList()].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
	};

	return <CountWithTooltip {...props} />;
};

ClientsCount.propTypes = {};

ClientsCount.defaultProps = {};

export default ClientsCount;
